export default {
  methods: {
    getMaxUploadSize(size){
      let maxSize = size || 5  // 5mb
      let total = 0
      Object.keys(this.uploadedFiles).map(key =>{
        total += (this.uploadedFiles[key].size / 1048576)
      })
      return total > maxSize
    },
    getMaxUploadSizeMsg(size){
      let maxSize = size || 5
      return 'Bendras įkeliamų dokumentų dydis negali viršyti ' + maxSize + 'mb'
    }
  }
}
